import { CreditReport } from './CreditReport';

export default CreditReport;
